import axios from "axios";
import { logClientError } from "./clientLog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

// Record unexpected API failures (network errors, validation 422s, and 5xx) to the DB
// so we can review them. Expected auth/permission responses (400/401/403/404) are skipped.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    try {
      const resp = error.response;
      const status = resp?.status;
      if (!resp || status === 422 || status >= 500) {
        let detail = "";
        try { detail = typeof resp?.data === "string" ? resp.data : JSON.stringify(resp?.data); } catch (e) { detail = ""; }
        const cfg = error.config || {};
        logClientError({
          source: "api-error",
          message: `${status || "network-error"} ${(cfg.method || "").toUpperCase()} ${cfg.url || ""}`.trim(),
          stack: (detail || error.message || "").slice(0, 4000),
          context: cfg.url || "",
        });
      }
    } catch (e) { /* never let logging break the app */ }
    return Promise.reject(error);
  }
);

export default api;
export { API };
